import styled from 'styled-components'
const LineItemsWrapper = styled.div`
  .editable-cell {
    position: relative;
  }

  .editable-cell-value-wrap {
    padding: 5px 12px;
    cursor: pointer;
  }

  .editable-row:hover .editable-cell-value-wrap {
    border: 1px solid ${(props) => props.theme.tokens.borderInput};
    border-radius: 4px;
    padding: 4px 11px;
  }

  .icon-edit {
    margin-right: 10px;
  }

  .hide {
    display: none;
  }

  .text-grey {
    color: gray;
  }

  .mobile-edit-hint {
    text-align: center;
    padding: 8px;
    background: ${(props) => props.theme.tokens.highlightWarning};
    border: 1px dashed #ffe58f;
    border-radius: 4px;
    margin-bottom: 12px;
    font-size: 12px;
  }

  .line-items-mobile-list .line-item-card {
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
  }

  .line-items-mobile-list .line-item-card.is-service {
    background: ${(props) => props.theme.tokens.surfaceHover};
    border-style: dashed;
  }

  .line-items-mobile-list .card-row {
    margin-bottom: 4px;
  }

  .line-items-mobile-list .card-row:last-child {
    margin-bottom: 0;
  }

  .line-items-mobile-list .card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
  }

  .line-items-mobile-list .card-header .position {
    color: ${(props) => props.theme.tokens.textMuted};
    font-size: 12px;
    flex-shrink: 0;
  }

  .line-items-mobile-list .card-header .name {
    flex: 1;
    word-break: break-word;
  }

  .line-items-mobile-list .subtle {
    color: ${(props) => props.theme.tokens.textMuted};
    font-size: 12px;
  }

  .line-items-mobile-list .card-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    font-size: 13px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px dashed ${(props) => props.theme.tokens.borderSubtle};
  }

  .line-items-mobile-list .card-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
  }
`
export default LineItemsWrapper